// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  shipmentId: __t.u64().primaryKey().name("shipment_id"),
  firmId: __t.u64().name("firm_id"),
  fromKey: __t.string().name("from_key"),
  toKey: __t.string().name("to_key"),
  familyKey: __t.string().name("family_key"),
  qty: __t.u32(),
  valueSov: __t.i64().name("value_sov"),
  departAt: __t.timestamp().name("depart_at"),
  arriveAt: __t.timestamp().name("arrive_at"),
  ambushAt: __t.timestamp().name("ambush_at"),
  ambushRoll: __t.f32().name("ambush_roll"),
  ambushRolled: __t.bool().name("ambush_rolled"),
  state: __t.string(),
  escortedBy: __t.identity().name("escorted_by"),
  escortProjectId: __t.u64().name("escort_project_id"),
  lossX: __t.f64().name("loss_x"),
  lossY: __t.f64().name("loss_y"),
  lossZ: __t.f64().name("loss_z"),
  updatedAt: __t.timestamp().name("updated_at"),
});
